import React, { useReducer } from 'react'
import { businessTypeOpeningsGetByInduction, businessTypeOpeningsGet } from '../../services/businessTypeOpeningsService';
import { logout } from '../../services/loginService';

import BusinessTypeOpeningsContext from './BusinessTypeOpeningsContext';
import BusinessTypeOpeningsReducer from './BusinessTypeOpeningsReducer';

export const BusinessTypeOpeningsState = ({ children }) => {
    const initialState = {
        businessTypeOpenings: [],
        isFetching: true,
        error: false,
        message: '',
        tokenError: false
    }

    const [state, dispatch] = useReducer(BusinessTypeOpeningsReducer, initialState);

    const getBusinessTypeOpenings = async () => {
        try {
            const response = await businessTypeOpeningsGet()
            if (response.ok) {
                dispatch({
                    type: 'GET_BUSINESS_TYPES_OPENINGS',
                    payload: response.data,
                })
            } else {
                switch (response.data.status) {
                    case 401:
                        dispatch({
                            type: 'UNATORIZED',
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_BUSINESS_TYPES_OPENINGS',
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_BUSINESS_TYPES_OPENINGS',
            })
            console.log(e)
        }
    }


    const getBusinessTypeOpeningsByInduction = async (id) => {
        try {
            const response = await businessTypeOpeningsGetByInduction(id)
            if (response.ok) {
                dispatch({
                    type: 'GET_BUSINESS_TYPES_OPENINGS',
                    payload: response.data,
                })
            } else {
                switch (response.data.status) {
                    case 401:
                        dispatch({
                            type: 'UNATORIZED',
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_BUSINESS_TYPES_OPENINGS',
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_BUSINESS_TYPES_OPENINGS',
            })
            console.log(e)
        }
    }

    return (
        <BusinessTypeOpeningsContext.Provider
            value={{
                businessTypeOpeningsState: state,
                getBusinessTypeOpenings,
                getBusinessTypeOpeningsByInduction
            }}
        >
            {children}
        </BusinessTypeOpeningsContext.Provider>
    )
}
